pm.appConfig = {
	apiAddress: "https://piktomir.ru/api/v4/",
	authAddress: "https://account.infomir.ru/",
	mlURL: "https://mld.piktomir.ru/post",
	writablePathPrefix: "prod",
	pmAppID: "FDcQKg7RUw",
	useDefaultWorlds: false,
	canLogIn: true,
	showMarket: false,
	showInternalSettings: false,
	useNetworkFeatures: false,
	recognizeType: "remote",
	demoWorldID: "5784b4278666565302423ed7",
	builtinWorlds: {
		"pm": [
			{
				id: "55881818a43c62246e1a542e",
				name: "Базовый",
				sourceName: "Base",
				description: "Мир с базовым набором заданий",
				createDate: "2017-02-28T09:21:56.659+0000",
				owner: {id: "55881339a561e76d4fb9285d", name: "НИИСИ"}
			},
			{
				id: "5588181ca43c62246e1a5433",
				name: "Алгоритмика",
				sourceName: "Alg",
				description: "Мир с расширенным набором заданий",
				createDate: "2017-02-28T09:21:57.830+0000",
				owner: {id: "55881339a561e76d4fb9285d", name: "НИИСИ"}
			},
			{
				id: "5784b4278666565302423ed7",
				name: "Демо",
				sourceName: "Demo",
				description: "Мир с демо заданиями",
				createDate: "2016-02-28T09:21:55.480+0000",
				owner: {id: "55881339a561e76d4fb9285d", name: "НИИСИ"}
			},
			{
				id: "5784c055fb2dc65c02a59c7f",
				name: "Алгоритмика 2018",
				sourceName: "Alg2018",
				description: "Мир с расширенным набором заданий",
				createDate: "2018-03-23T11:54:47.316+0000",
				owner: {id: "55881339a561e76d4fb9285d", name: "НИИСИ"}
			},
			{
				id: "591c27dd3ce609067f59b70f",
				name: "Весь ПиктоМир",
				sourceName: "WholePM",
				description: "Мир с различными заданиями",
				createDate: "2018-02-28T09:21:55.178+0000",
				owner: {id: "55881339a561e76d4fb9285d", name: "НИИСИ"}
			}
		],
		"pm-k": [
			{
				id: "5d88e6fcfdcd43315337d241",
				name: "2 класс. Весна",
				sourceName: "SecondClass",
				description: "Мир с базовым набором заданий для 2 класса",
				createDate: "2019-04-28T17:09:04.914Z",
				owner: {id: "55881339a561e76d4fb9285d", name: "НИИСИ"}
			}
		]
	}
};
